import React, { useContext, useEffect, useState } from 'react'
import { relatesVideos, relatesVideosBS, relatesVideosGA, relatesVideosRL } from '../../Services/allApi'
import { addcontext } from '../../ContextShare/ContextShare'
import { useNavigate, useParams } from 'react-router-dom'
import language from '../../language.json'

function RelatedVideos() {
    const baseUrl=process.env.REACT_APP_BASEURL
    const params=useParams()
    const videoIdFromUrl=params.vId
    const [vIdToUrl,setvIdToUrl]=useState()
    const navigate=useNavigate()
    const [relatedVideos,setrelatedVideos]=useState([])
    const {videoData,setVideoData}=useContext(addcontext)
    const {whichPageIsSendingData,setwhichPageIsSendingData}=useContext(addcontext)
    const {videoUrl,setVideoUrl}=useContext(addcontext)
    const {videoThumb,setVideoThumb}=useContext(addcontext)
    const [isSeeMore,setIsSeeMore]=useState(false)
    const {newIdP,setnewIdP}=useContext(addcontext)
    const {langChanged,setlangChanged}=useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
  
    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')
  },[currentLanguage,langChanged])
    
  // get related videos by mapping id
    const relatedVideosApi=async(newId)=>{
        const result=await relatesVideos(newId)
        setrelatedVideos(result?.data)
        console.log(result);
        // navigate(`/video/:${}`);

        
    }
    useEffect(()=>{
        const newId=videoIdFromUrl?.replace(/:/g, '')
        setvIdToUrl(newId)
        if(vIdToUrl){
          console.log(vIdToUrl);
          relatedVideosApi(newId)
        }
      },[vIdToUrl,newIdP])
    
    //on clicking related videos pass the mapping id to url then it will change / refresh the entire page 
    const handleRelatedVideosPlay=(e)=>{
        setVideoData(e)
        setVideoUrl(e.video_url)
        setVideoThumb(e.video_thumbnail)
        const newUrlParms=e?.mapping_id
        setvIdToUrl(newUrlParms)
        if(newUrlParms){
            navigate(`/video/:${newUrlParms}`)
            setnewIdP(newIdP+1)
        // console.log(e);
        }
    }
  return (
    <>
    {relatedVideos?.length>0&&<div className='w-full h-full flex justify-center'>
        <div className='lg:w-9/12 w-11/12  h-64 mt-5 flex flex-col'>
           <div><h3 className='lg:text-left text-center mb-8 text-lg'>{language.Related_Videos[currentLanguage]}</h3></div>
           {/* <div className='flex flex-col'> */}
            <div className='flex flex-wrap gap-6 lg:justify-between justify-center pb-10'>
                {relatedVideos?.slice(0, isSeeMore ? relatedVideos.length : 3).map((videos,index)=>(
                    <div
                    key={index}
                     onClick={()=>handleRelatedVideosPlay(videos)} className='cursor-pointer xl:h-36 h-60 hover:shadow-xl lg:w-3/12 w-2/5 rounded-lg flex xl:flex-row flex-col  justify-evenly' style={{border:'1px solid #001F33'}} >
                        {/* video img */}
                        <div className='flex items-center justify-evenly'><img className='md:w-24 w-16 md:h-24 h-16 rounded-full lg:ms-4 ms-0 lg:mt-0 mt-5' src={videos?.video_thumbnail?`${baseUrl}${whichPageIsSendingData=='govaddress'?videos?.address_thumbnail:whichPageIsSendingData=='budgetspeech'?videos?.speech_thumbnail:whichPageIsSendingData=='rulings'?videos?.rulings_thumbnail:videos?.video_thumbnail}`:'https://eniyamasabha.in/assets/img/logo-login.svg'}alt="Video logo" /></div>
                        {/* title and sub-title */}
                        <div className='flex flex-col xl:w-8/12 w-full '>
                            <div className='flex lg:justify-start justify-center'><p className='mt-6 lg:ms-6 ms-0 '>{currentLanguage=='en'?videos?.video_event:videos.malayalam_video_event}</p></div>
                            <div className='flex lg:justify-start justify-center lg:text-start text-center'> <p className='text-sm mt-2 lg:ms-6 ms-0'  style={{ color: '#878787' }}>{currentLanguage=='en'?videos?.video_member:videos?.malayalam_video_member}</p></div>
                            <div className='flex lg:justify-start justify-center lg:text-start text-center'> <p className='text-sm mt-2 lg:ms-6 ms-0'  style={{ color: '#878787' }}>{videos?.video_upload_date||""}</p></div>
                        </div>
                    </div>
                ))}
               

                </div>

       {relatedVideos?.length>3&& <div className='flex justify-end text-blue-500 cursor-pointer' onClick={()=>setIsSeeMore(!isSeeMore)}>{!isSeeMore?'See more':'See less'}</div>}
           {/* </div> */}
        </div>
    </div>}
    </>
  )
}

export default RelatedVideos